class Widget {
  static ACTIVE = 'ACTIVE';
  static INACTIVE = 'INACTIVE';

  constructor() {
    this.status = Widget.ACTIVE;
  }

  isActive() {
    return this.status === Widget.ACTIVE;
  }
}

export default Widget;
